import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './Components/app/app.component';
import {ScheduleButtonComponent} from './Components/schedule-button/schedule-button.component';
import {CalendarComponent, CalendarHeaderComponent} from './Components/calendar/calendar.component';
import {HeaderComponent} from './Components/header/header.component';
import {CalendarTodayService} from './Services/calendar-today/calendar-today.service';
import {
  TimeSelectorComponent, TimeSelectorHeaderComponent
} from './Components/time-selector/time-selector.component';
import {ReviewInfoComponent} from './Components/review-info/review-info.component';
import {EditInfoComponent} from './Components/edit-info/edit-info.component';
import {FormsModule} from "@angular/forms";
import {TimezoneService} from './Services/timezone/timezone.service';
import {TimezoneSelectorComponent} from './Components/timezone-selector/timezone-selector.component';
import {AppointmentsService} from './Services/appointments/appointments.service';
import {ContactInfoService} from "./Services/contact-info/contact-info.service";
import {MobileCalendarComponent} from './Components/mobile-calendar/mobile-calendar.component';
import {DesktopCalendarComponent} from './Components/desktop-calendar/desktop-calendar.component';
import {HttpModule} from "@angular/http";
import {SafeNavigatePipe} from './safe-navigate.pipe';
import {CapitalizePipe} from './capitalize.pipe';
import {DesktopTimezoneSelectorComponent} from './Components/desktop-timezone-selector/desktop-timezone-selector.component';
import {ModalComponent} from './Components/modal/modal.component';
import {ModalCloserService} from './modal-closer.service';
import {DesktopEditInfoComponent} from './Components/desktop-edit-info/desktop-edit-info.component';
import {DesktopCancelDemoComponent} from './Components/desktop-cancel-demo/desktop-cancel-demo.component';
import {DesktopAddToCalendarComponent} from './Components/desktop-add-to-calendar/desktop-add-to-calendar.component';
import {CancelDemoComponent} from './Components/cancel-demo/cancel-demo.component';
import {YoureAllSetComponent} from './Components/youre-all-set/youre-all-set.component';


@NgModule({
  declarations: [
    AppComponent,
    ScheduleButtonComponent,
    CalendarComponent,
    HeaderComponent,
    CalendarHeaderComponent,
    TimeSelectorComponent,
    TimeSelectorHeaderComponent,
    ReviewInfoComponent,
    EditInfoComponent,
    TimezoneSelectorComponent,
    MobileCalendarComponent,
    DesktopCalendarComponent,
    SafeNavigatePipe,
    CapitalizePipe,
    DesktopTimezoneSelectorComponent,
    ModalComponent,
    DesktopEditInfoComponent,
    DesktopCancelDemoComponent,
    DesktopAddToCalendarComponent,
    CancelDemoComponent,
    YoureAllSetComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpModule,
  ],
  providers: [CalendarTodayService, TimezoneService, AppointmentsService, ContactInfoService, ModalCloserService],
  bootstrap: [AppComponent],
  entryComponents: [CalendarHeaderComponent, TimeSelectorHeaderComponent, DesktopTimezoneSelectorComponent, DesktopEditInfoComponent, DesktopCancelDemoComponent, DesktopAddToCalendarComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts